import React from 'react';
import StyleTabContent from './style-tab-content';
import ActionTabContent from './action-tab-content';

export default function TabContents(props) {
  const content = {
    style: <StyleTabContent {...props} />,
    action: <ActionTabContent {...props} />
  };

  return content[props.selectedTab] || null;
}

TabContents.propTypes = {
  selectedTab: React.PropTypes.oneOf(['style', 'action']).isRequired,
};



// WEBPACK FOOTER //
// ./src/ui/inline-text/tab-contents.jsx